<div class="check-in-end">
    <section>
      <info-page-header
        label="Check-In"
        [sublabel]="'Adulto'">
      </info-page-header>
      <div class="check-in-end-content">
          <p>El check-in del adulto se ha completado correctamente.</p>
          <button *ngIf="hasTravelRegister"
                  type="button"
                  class="primary-btn"
                  [routerLink]="['/contract']"
                  [queryParams]="{ url: travelRegisterFileURL }"
                  data-testid="travel-register-download-button"
          >
              Descargar Parte de viajeros
          </button>
          <button *ngIf="hasContract"
                  type="button"
                  class="primary-btn"
                  [routerLink]="['/contract']"
                  [queryParams]="{ url: contractUrl }"
                  data-testid="contract-download-button"
          >
              Descargar contrato
          </button>


          <button type="button" class="primary-btn" (click)="closeCheckIn()" data-testid="check-in-end-close-button">
              Cerrar
          </button>
      </div>
    </section>
</div>
